import { AdjacentType, ComparisonType, LogicalOperatorType } from "@iotv/iotv-v3-types";
import { apiKeyTypeId, getQueryBody } from '@iotv/datamodel-core';
import { ConsumerDao } from "../../../../data/ConsumerDAO";
export const getApiKeysRecordsForCustomer = async (customer) => {
    const getKeyByCustomerParams = getQueryBody({
        adjacencyType: AdjacentType.CHILD,
        contextObject: customer,
        filterGroups: [
            {
                filters: [
                    { key: 'type', predicate: ComparisonType.EQUALS, value: apiKeyTypeId }
                ], setOperation: LogicalOperatorType.AND
            }
        ]
    });
    const { err, data } = await ConsumerDao.baseQuery(getKeyByCustomerParams);
    return { err, data };
};
